export const WHALE_MIN_PURCHASES = 5;

export function isWhale(purchaseCount: number | null | undefined): boolean {
  return (purchaseCount ?? 0) >= WHALE_MIN_PURCHASES;
}

export const VIP_BENEFITS = [
  "Unlimited credit refunds for unsatisfied generations",
  "Priority processing with lower failure rates",
  "Dedicated VIP support queue",
  "Early access to new models and features",
  "Extended asset retention while active",
] as const;

export const VIP_SUPPORT_EMAIL = "support@animepup.com";
